import { useState } from 'react';
import { useSnackbar } from 'notistack';
import { getMessage } from 'helpers/helper';
import FS from 'services/fileService';

export default function useImageTemplates() {
  const { enqueueSnackbar } = useSnackbar();

  const [open, setOpen] = useState(false);
  const [templates, setTemplates] = useState({});
  const [loading, setLoading] = useState({});
  const [currentSection, setCurrentSection] = useState(null);

  const loadTemplates = async sectionTitle => {
    if (!sectionTitle) return;

    if (templates[sectionTitle]?.length) return;
    if (loading[sectionTitle]) return;

    try {
      setLoading(prev => ({ ...prev, [sectionTitle]: true }));

      const response = await FS.getTemplates(sectionTitle);
      const list = response.data?.response_data || [];

      setTemplates(prev => ({ ...prev, [sectionTitle]: list }));
    } catch (error) {
      enqueueSnackbar(getMessage(error?.response?.data, 'error'), {
        variant: 'error',
      });
    } finally {
      setLoading(prev => ({ ...prev, [sectionTitle]: false }));
    }
  };

  const openModal = async sectionTitle => {
    setCurrentSection(sectionTitle);
    setOpen(true);
    await loadTemplates(sectionTitle);
  };

  const closeModal = () => setOpen(false);

  return {
    open,
    openModal,
    closeModal,
    currentSection,
    templates,
    loading,
    currentTemplates: currentSection ? templates[currentSection] || [] : [],
    currentLoading: currentSection ? loading[currentSection] || false : false,
  };
}
